import { PageTypeEnum } from './types.es.js';

const paramToUrl = (params, baseUrl, key) => {
    const url = new URL(`${baseUrl}/${key || 'search'}`);
    if (params) {
        Object.keys(params).forEach((key) => {
            if (Array.isArray(params[key]) && !params[key].length)
                return;
            return url.searchParams.append(key, params[key]);
        });
    }
    return url;
};
const getObjFromQueryString = (str) => {
    const urlParams = new URLSearchParams(str);
    const result = {};
    for (const pair of urlParams.entries()) {
        result[pair[0]] = pair[1];
    }
    return result;
};
const cookFilterOption = (el, filterCode, filterName, params) => {
    var _a, _b;
    const optionName = el.name || el.value;
    const optionCode = el.code || el.optionId || ((_a = el.id) === null || _a === void 0 ? void 0 : _a.toString());
    if (!params ||
        !((_b = params[filterCode]) === null || _b === void 0 ? void 0 : _b.toString().split(',').includes(optionCode)))
        return {
            optionName,
            optionCode,
            filterCode,
            filterName,
        };
};
const cookFilter = (filter, params, categories) => {
    var _a;
    const newFilter = [];
    if (!filter)
        return newFilter;
    if (categories === null || categories === void 0 ? void 0 : categories.length) {
        newFilter.push({
            code: 'masterCategories',
            name: 'Danh mục sản phẩm',
            options: categories
                .map((val) => cookFilterOption(val, 'masterCategories', 'Danh mục sản phẩm', params))
                .filter(Boolean),
        });
    }
    if (filter.brands.length) {
        newFilter.push({
            code: 'brands',
            name: 'Thương hiệu',
            options: filter.brands
                .map((val) => cookFilterOption(val, 'brands', 'Thương hiệu', params))
                .filter(Boolean),
        });
    }
    if ((_a = filter === null || filter === void 0 ? void 0 : filter.clearanceTypes) === null || _a === void 0 ? void 0 : _a.length) {
        newFilter.push({
            code: 'clearanceTypeIds',
            name: 'Tình trạng sản phẩm',
            options: filter.clearanceTypes
                .map((val) => cookFilterOption(val, 'clearanceTypeIds', 'Tình trạng sản phẩm', params))
                .filter(Boolean),
        });
    }
    filter.attributes.forEach((el) => {
        newFilter.push({
            code: `attributes.${el.code}`,
            name: el.name,
            options: el.values
                .map((val) => cookFilterOption(val, `attributes.${el.code}`, el.name, params))
                .filter(Boolean),
        });
    });
    return newFilter.filter((filter) => !!filter.options.length);
};
const cookSearchIntent = (result) => {
    if (!result)
        return null;
    const { brands = [], sellers = [], masterCategories = [] } = result;
    const cookedIntentSellers = sellers.map((el) => ({
        id: el.id,
        type: PageTypeEnum.SELLER,
        text: el.displayName,
        logo: el.logo,
    }));
    const cookedIntentBrands = brands.map((el) => ({
        id: el.code,
        type: PageTypeEnum.BRAND,
        text: el.name,
        logo: el.logo,
    }));
    const cookedIntentCategories = masterCategories.map((el) => ({
        id: el.id,
        type: PageTypeEnum.CATEGORY,
        text: el.name,
    }));
    return {
        sellers: cookedIntentSellers,
        others: [...cookedIntentBrands, ...cookedIntentCategories],
    };
};

export { cookFilter, cookSearchIntent, getObjFromQueryString, paramToUrl };
